import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { Line } from "vue-chartjs";
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  LineElement,
  LinearScale,
  PointElement,
  CategoryScale,
  ChartOptions,
} from "chart.js";
import { useStore } from "@/store";
import { ref, watch, toRefs, onUnmounted } from "vue";


export default /*#__PURE__*/_defineComponent({
  props: {
    chartId: null,
    datasetIdKey: null,
    width: null,
    height: null,
    cssClasses: null,
    target: null
  },
  setup(__props: any) {

const props = __props as {
  chartId?: string;
  datasetIdKey?: string;
  width?: number;
  height?: number;
  cssClasses?: string;
  target: string;
}

ChartJS.register(
  Title,
  Tooltip,
  LineElement,
  LinearScale,
  PointElement,
  CategoryScale
);



const store = useStore();
const { time, currentRunner } = toRefs(store);
const { target } = toRefs(props);

store.registerOutput(target.value);
onUnmounted(() => {
  store.UnregisterOutput(target.value);
});

watch(time, () => {
  chartData.value.datasets[0].data[time.value.toFixed(2)] =
    store.runnerOutputs[target.value];
});

watch(currentRunner, () => {
  chartData.value.datasets[0].data = {};
});

const chartData = ref<{ datasets: { data: Record<string, number> }[] }>({
  datasets: [
    {
      data: {},
    },
  ],
});

watch(toRefs(props).target, (target, prevTarget) => {
  if (prevTarget !== target) {
    chartData.value.datasets[0].data = {};
  }
});

const chartOptions = ref<ChartOptions>({
  responsive: true,
  animation: false,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Line), {
    "chart-options": (chartOptions.value as any),
    "chart-data": (chartData.value as any)
  }, null, 8, ["chart-options", "chart-data"]))
}
}

})